import { Trash2 } from "lucide-react";
import { useFieldArray, useFormContext } from "react-hook-form";

import FormInput from "@/components/form-fields/form-input";
import { FileUploaderComponent } from "@/components/reusables/FileUpload";
import ButtonWithIcon from "@/components/ui/ButtonWithIcon";
import { ScrollArea } from "@/components/ui/scroll-area";
import { ToolsConstants } from "@/constants/tools.constant";
import {
  TAddSubProductItem,
  emptySubProductItems,
} from "@/schemas/tools.schema";

const SubProductItemForm = (): JSX.Element => {
  const form = useFormContext<TAddSubProductItem>();
  const { control, getValues } = form;
  const { fields, append, remove } = useFieldArray({
    name: "items",
    control,
    keyName: "idx",
  });

  const isForBulkUpload = getValues("isBulkUpload");

  return (
    <ScrollArea>
      {fields?.map((field, index) => {
        if (!isForBulkUpload) {
          return (
            <div className='space-y-4 p-2' key={field.idx}>
              <FormInput
                form={form}
                name={`items.${index}.name`}
                label='Name'
                required
                input={{
                  placeholder: "Enter Product Name",
                }}
              />
              <FormInput
                name={`items.${index}.images`}
                form={form}
                render={(field, _, formState) => {
                  return (
                    <FileUploaderComponent
                      field={field}
                      formState={formState}
                      isMultiple={true}
                      maxFilePreview={4}
                      labelsProps={{
                        label: "Upload Image",
                        showLabel: true,
                      }}
                      {...field}
                    />
                  );
                }}
              />
              <FormInput
                form={form}
                name={`items.${index}.modelNumber`}
                required
                label='Model Number'
                input={{
                  placeholder: "Enter Model Number",
                  type: "number",
                }}
              />
            </div>
          );
        }

        return (
          <div
            className='grid grid-cols-3 space-y-8 items-end gap-4 pl-2'
            key={field.idx}
          >
            <FormInput
              form={form}
              name={`items.${index}.name`}
              label='Name'
              required
              input={{
                placeholder: "Enter Product Name",
              }}
            />
            <FormInput
              name={`items.${index}.images`}
              form={form}
              render={(field, _, formState) => {
                return (
                  <FileUploaderComponent
                    field={field}
                    formState={formState}
                    isMultiple={true}
                    maxFilePreview={4}
                    labelsProps={{
                      label: "Upload Image",
                      showLabel: true,
                    }}
                    {...field}
                  />
                );
              }}
            />
            <div className='flex items-center gap-2 pr-2'>
              <FormInput
                form={form}
                name={`items.${index}.modelNumber`}
                required
                label='Model Number'
                className='w-full'
                input={{
                  placeholder: "Enter Model Number",
                  type: "number",
                }}
              />
              <Trash2
                className='w-5 h-5 text-destructive cursor-pointer'
                onClick={() => remove(index)}
              />
            </div>
          </div>
        );
      })}
      {isForBulkUpload && (
        <div className='mt-8 space-x-9'>
          <ButtonWithIcon
            variant={"secondary"}
            onClick={() => append(emptySubProductItems)}
          >
            {ToolsConstants.FORM.ITEMS.ADD_ROW}
          </ButtonWithIcon>
          <ButtonWithIcon
            variant={"secondary"}
            onClick={() => {
              for (let i = 0; i < 5; i++) {
                append(emptySubProductItems);
              }
            }}
          >
            {ToolsConstants.FORM.ITEMS.ADD_FIVE_ROW}
          </ButtonWithIcon>
        </div>
      )}
    </ScrollArea>
  );
};

export default SubProductItemForm;
